module.exports = __webpack_public_path__ + "static/media/race-room-on.0ab216a3.png";